import React, { useEffect, useRef, useState } from 'react';
import MakeATabView from '../hunt-planner/reusableComponents/tabView/tabView';
import { connect } from 'react-redux'
import './index.scss'
import { selectedTabAction } from '../../action/selected-tab-action';
import { expandMorefilterMenu } from '../../action/huntplanner-morefilters-actions';
import { huntPlannerRightMenuBarHide } from '../../action/huntplanner-menu-bar';
import ReusableButton from '../hunt-planner/reusableComponents/button/customButton';
import { multiTileHuntLayersXYZ, multiTileHuntLayersXYZTwoLayers } from '../hunt-planner/huntplanner-layer-render/renderlayerFunction';
import { fetchGetStoreCode } from '../../action/getStoreCode';
import { ARTEMIS_CONVERSATIONS_ENABLED } from '../../action/artemis-actions/agent-actions';
import { collapseLeftToolbar } from '../../action/left-toolbar-state-actions';
import Icon from '../artemis-functionality/components/icons';
import { fetchArtemisAlerts, fetchArtemisAlertsInbox, fetchArtemisConversation, fetchArtemisMentions } from '../../action/artemis-actions/query-action';
import { badgeStore, lookUpBadges, tabBadge } from '../../lib/artemis/hub';

// How often the ARTEMIS tab's badge is looked up while another tab is open (the hub keeps it current itself).
const ARTEMIS_BADGE_EVERY_MS = 60000

const TopMenu = (props) => {
    const [selectedTab, setSelectedTab] = useState(props.selectedTabvalue || null);
    const [xyz, setXYZ] = useState(false)
    const [xYZDouble, setXYZDouble] = useState(false)
    // Another screen can change the tab (Artemis's View all, Show in Hunt Planner).
    useEffect(() => { if (props.selectedTabvalue) setSelectedTab(props.selectedTabvalue) }, [props.selectedTabvalue])

    // The ARTEMIS tab's badge (WEB-7168): new alerts in orange, else @mentions.
    const [artemisBadges, setArtemisBadges] = useState(badgeStore.get())
    useEffect(() => badgeStore.subscribe(setArtemisBadges), [])
    const tabRef = useRef(selectedTab)
    tabRef.current = selectedTab
    useEffect(() => {
        if (!ARTEMIS_CONVERSATIONS_ENABLED || !props.signedIn) return undefined
        const api = { inbox: props.fetchArtemisAlertsInbox, alerts: props.fetchArtemisAlerts, conversation: props.fetchArtemisConversation, mentions: props.fetchArtemisMentions }
        const cache = {}
        const look = () => {
            if (document.hidden || tabRef.current === 'artemis') return
            lookUpBadges(api, cache).then(badgeStore.set).catch(() => {})
        }
        look()
        const timer = setInterval(look, ARTEMIS_BADGE_EVERY_MS)
        return () => clearInterval(timer)
    }, [props.signedIn])
    const artemisBadge = tabBadge(artemisBadges)

    const handleTabChange = (tab, label) => {
        setSelectedTab(tab);
        props.selectedTabAction(tab)
        if (tab == 'map') {
            props.expandMorefilterMenu(false)
            props.huntPlannerRightMenuBarHide()
        }
        // The map's Artemis panel closes, so its chat carries on in the full view instead of in two places.
        if (tab == 'artemis' && props.leftToolbarState && props.leftToolbarState.dialog === 'artemis') {
            props.collapseLeftToolbar()
        }
        console.log(`Tab changed to: ${label}`);
    };

    const tabs = [
        { tab: 'map', label: 'Map' },
        { tab: 'huntplanner', label: 'Hunt Planner' },
    ];

    let handleClickXYZ = () => {
        setXYZ(!xyz)
        multiTileHuntLayersXYZ(props.mapReference)
        if (xyz) {
            props.mapReference.overlayMapTypes.clear();
        }
    }


    let handleDoubleLayer = () => {
        setXYZDouble(!xYZDouble)
        multiTileHuntLayersXYZTwoLayers(props.mapReference)
        if (xYZDouble) {
            props.mapReference.overlayMapTypes.clear();
        }
    }

    let onHandleGearStore = () => {
        props.fetchGetStoreCode()
            .then((res) => {
                console.log("Response from PromoCode/GetStoreCode : ", res);
                window.open(`https://shop.basemap.com/?bm_discount=${res.code}&bm_percent_off=${res.percentOff}`);
            })
            .catch((err) => {
                console.log("error while fetching get promocode/GetStoreCode ", err);
            });
    };

    return (
        <div className='top-menu-container'>

            <div className='top-menu-tab-container'>
                <MakeATabView
                    key={'map'}
                    tabWidth="120px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    properties={{ tab: 'map', label: 'Map' }}
                    disable={false}
                />
            </div>


            <div className='top-menu-tab-container'>
                <MakeATabView
                    key='huntplanner'
                    properties={{ tab: 'huntplanner', label: 'Hunt Planner' }}
                    tabWidth="120px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    disable={props.isHuntPlannerDisable}
                />
            </div>

            {/* The full-screen Artemis view; it needs saved chats for its sessions list. */}
            {ARTEMIS_CONVERSATIONS_ENABLED && (
                <div className='top-menu-tab-container'>
                    <MakeATabView
                        key={'artemis'}
                        properties={{
                            tab: 'artemis', label: 'Artemis', icon: <span className='top-menu-artemis-icon'><Icon name="sparkle" size={17} /></span>,
                            badge: artemisBadge && <span className={`top-menu-artemis-badge top-menu-artemis-badge-${artemisBadge.kind}`} aria-label={artemisBadge.label}>{artemisBadge.text}</span>
                        }}
                        tabWidth="120px"
                        tabHeight="40px"
                        selectedTab={selectedTab}
                        setTab={handleTabChange}
                        disable={false}
                    />
                </div>
            )}

            <div className='top-menu-tab-container'>
                <MakeATabView
                    key={'recreationAccess'}
                    properties={{ tab: 'recreationAccess', label: 'Private Land Access' }}
                    tabWidth="170px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    disable={false}
                />
            </div>

            <div className='top-menu-tab-container'>
                <MakeATabView
                    key={'gearStore'}
                    properties={{ tab: 'gearStore', label: 'Gear Store' }}
                    tabWidth="130px"
                    tabHeight="40px"
                    selectedTab={selectedTab}
                    setTab={handleTabChange}
                    onClick={() => onHandleGearStore()}
                    disable={false}
                />
            </div>

        </div>
    );
};



const mapStateToProps = state => ({
    selectedTabvalue: state.selectedTab,
    signedIn: !!(state.auth && state.auth.token),
    leftToolbarState: state.leftToolbarState,
    isHuntPlannerDisable: state.isHuntPlannerDisable,
    mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
})

const mapDispatchToProps = dispatch => ({
    selectedTabAction: (payload) => dispatch(selectedTabAction(payload)),
    fetchArtemisAlertsInbox: () => dispatch(fetchArtemisAlertsInbox()),
    fetchArtemisAlerts: () => dispatch(fetchArtemisAlerts()),
    fetchArtemisConversation: id => dispatch(fetchArtemisConversation(id)),
    fetchArtemisMentions: () => dispatch(fetchArtemisMentions()),
    collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
    expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
    huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide()),
    fetchGetStoreCode: () => dispatch(fetchGetStoreCode())
})


// export default TopMenu;
export default connect(mapStateToProps, mapDispatchToProps)(TopMenu)


